<template>
    <nav class="menu" :class="'menu-'+location">
        <WpNaviLinks :menu="menu" />
        <slot></slot>
    </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WpNaviLinks from '@/components/elements/WpNaviLinks';

export default {
    name: 'wp-navi',
    props: ['location'],
    components:{
        WpNaviLinks
    },
	mounted() {
        let menu = this.getMenu(this.location);
        if(!menu.length){ 
            this.loadMenu(this.location).then(() => { this.menu = this.getMenu(this.location) })
        } else{ this.menu = menu }
	},
	data() {
		return {
            hasActiveChild: false,
            menu: []
		};
    },
    computed: {
        ...mapGetters([
            'getMenu'
        ]),
    },
    methods:{
        ...mapActions([
			'loadMenu'
		]),
    },
};
</script>
